import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideTertiaireStub } from '../../../../config/aides-tertiaire';

export default function TertiairePretsBpifrancePage() {
  const aide = getAideTertiaireStub('prets-bpifrance');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="tertiaire" />;
}
